export default {
    chartAreaColours: [ "#F1C40F", "#E67E22", "#E74C3C", "#B33771", "#1ABC9C", "#2ECC71", "#3B3B98", "#9B59B6", "#1B9CFC" ],
    chartBorderColour: "#ffffff",
    chartAreaColoursHover: [ "#F1C40F80", "#E67E2280", "#E74C3C80", "#B3377180", "#1ABC9C80", "#2ECC7180", "#3B3B9880", "#9B59B680", "#1B9CFC80" ],
}